export const OFLC_UPDATE_USER_ROLE = 'OFLC_UPDATE_USER_ROLE';
export const OFLC_UPDATE_USER_ROLE_SUCCESS = 'OFLC_UPDATE_USER_ROLE_SUCCESS';
export const OFLC_UPDATE_USER_ROLE_FAILED = 'OFLC_UPDATE_USER_ROLE_FAILED';

export function updateUserRole(payload) {
	return {
		type: OFLC_UPDATE_USER_ROLE,
		payload
	};
}

export function updateUserRoleSuccess(payload) {
	return {
		type: OFLC_UPDATE_USER_ROLE_SUCCESS,
		payload: payload
	};
}

export function updateUserRoleFail(payload) {
	return {
		type: OFLC_UPDATE_USER_ROLE_FAILED,
		payload: payload
	};
}
